'use client';

import { ArrowLeft } from '@ironhack/design-system2/icons/arrow-left';
import { useRouter } from 'next/navigation';
import { type ReactElement } from 'react';

export const NavbarBack = (): ReactElement => {
  const router = useRouter();

  return (
    <ArrowLeft cursor="pointer" onClick={() => router.back()} role="button" />
  );
};
